import { render, staticRenderFns } from "./Viber.vue?vue&type=template&id=58a037f0&scoped=true"
import script from "./Viber.vue?vue&type=script&lang=js"
export * from "./Viber.vue?vue&type=script&lang=js"
import style0 from "./Viber.vue?vue&type=style&index=0&id=58a037f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a037f0",
  null
  
)

export default component.exports